import { RejectIcon } from '@/shared/assets';
import { COMMON_MESSAGES } from '@/shared/lib';
import {
  Button,
  ButtonProps,
  Heading,
  HeadingVariant,
  Typography,
} from '@/shared/ui';

interface DashboardWrongModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  descriptionText?: string;
  headingVariant?: HeadingVariant;
  btnText?: string;
  hideOverlay?: boolean;
  actionButton?: {
    text: string;
  } & ButtonProps;
}
export const DashboardWrongModalContent = ({
  title = COMMON_MESSAGES.SOMETHING_WENT_WRONG,
  descriptionText = COMMON_MESSAGES.PROBLEM_PROCESSING_REQUEST_TRY_AGAIN,
  btnText = 'Try again',
  onClose,
  headingVariant = 'l',
  actionButton,
}: Omit<DashboardWrongModalProps, 'isOpen'>) => {
  const { text, ...actionButtonProps } = actionButton ?? {};
  return (
    <div className="flex h-[532px] w-full flex-col items-center">
      <img className="h-[120px] w-[120px]" src={RejectIcon} alt="reject" />
      <div className="mt-10 flex w-full flex-col gap-4 px-10">
        <Heading variant={headingVariant}>{title}</Heading>
        <Typography variant="16-r" className="text-center">
          {descriptionText}
        </Typography>
      </div>
      <div className="mt-auto flex w-full flex-col gap-1 pt-5">
        <Button variant="contrast-500" size="lg" onClick={onClose}>
          {btnText}
        </Button>
        {actionButton && <Button {...actionButtonProps}>{text}</Button>}
      </div>
    </div>
  );
};
